export const graphqlID = (type: string, id: string | number) =>
  btoa(`${type}:${id}`);

export const getEncodedType = (id: string | null | undefined) =>
  id ? atob(id).split(":")[0] : null;
export const legacyID = (id: string) => atob(id).split(":")[1];
